import { Spacing } from "components/designV2/constants";
import styled from "styled-components";

export const SalaryList = styled.div`
  display: grid;
  gap: ${Spacing.md}px;
`;

export const EmptyStateText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Spacing.lg}px;
  margin-top: 40px;
  align-self: center;
`;
